<template>
  <div
    v-if="feedback.displayModal"
    class="w-full mx-auto rounded p-3 my-5 flex justify-between"
    :class="styling"
  >
    <p>{{ feedback.message }}</p>
    <span @click="resetFeedback" class="cursor-pointer">&#10006;</span>
  </div>
</template>

<script>
export default {
  name: "FeedbackMessage",
  props: {
    feedback: Object,
    resetFeedback: Function,
  },

  computed: {
    styling() {
      if (this.feedback.code === "success") {
        return "bg-teal-100 border border-teal-500 text-teal-500";
      } else {
        return "bg-red-100 border border-red-400 text-red-500";
      }
    },
  },
};
</script>